import SourceCategoryPagination from 'SourceComponent/CategoryPagination/CategoryPagination.component';

export class CategoryPagination extends SourceCategoryPagination {
    renderPreviousPageLink() {
        const {
            anchorTextPrevious,
            currentPage
        } = this.props;

        if (currentPage <= 1) {
            return (
                <li block="CategoryPagination" elem="ListItem" />
            );
        }

        return this.renderPageLink(
            currentPage - 1,
            'prev',
            anchorTextPrevious || this.renderPageIcon()
        );
    }

    renderNextPageLink() {
        const {
            anchorTextNext,
            currentPage,
            totalPages
        } = this.props;

        if (currentPage > totalPages - 1) {
            return (
                <li block="CategoryPagination" elem="ListItem" />
            );
        }

        return this.renderPageLink(
            currentPage + 1,
            'next',
            anchorTextNext || this.renderPageIcon(true)
        );
    }
}

export default CategoryPagination;
